import { z } from "zod";

export const PermitClassificationTypes = ["Residential", "Commercial", "Other"] as const;
export const PermitClassificationSchema = z.enum(PermitClassificationTypes);

export type PermitClassification = z.infer<typeof PermitClassificationSchema>;
